import React, { useEffect, useState } from "react";
import { Input } from "antd";
import Card from "./Card";
import Badge, { badgeVariantFromStatus } from "./Badge";
import Button from "./Button";

export function IntentCard({ intent, onUpdateEndpoint, isUpdating = false }) {
  const [showAuthKey, setShowAuthKey] = useState(false);
  const [endpointUrl, setEndpointUrl] = useState("");

  useEffect(() => {
    setEndpointUrl(intent?.endpointUrl || "");
  }, [intent?.endpointUrl]);

  if (!intent) return null;

  const statusVariant = badgeVariantFromStatus(intent.status, "success");
  const methodVariantMap = {
    GET: "primary",
    POST: "success",
    PUT: "warning",
    DELETE: "danger",
    PATCH: "warning",
  };
  const methodVariant = methodVariantMap[intent.method] || "muted";
  console.debug("added log");
  return (
    <Card className="intent-card">
      <div className="intent-header">
        <div>
          <div className="intent-name">{intent.name}</div>
          <div className="stack-inline intent-badges">
            <Badge variant={statusVariant}>{intent.status}</Badge>
            <Badge variant={methodVariant}>{intent.method}</Badge>
          </div>
        </div>
      </div>

      <div className="intent-description">{intent.description}</div>

      <div className="keyword-row">
        {intent.keywords?.map((keyword) => (
          <Badge key={keyword} variant="muted">
            {keyword}
          </Badge>
        ))}
      </div>

      <div className="response-box">
        <strong className="response-label">Endpoint URL</strong>
        <div className="intent-endpoint-editor">
          <Input
            className="intent-endpoint-input"
            value={endpointUrl}
            onChange={(event) => setEndpointUrl(event.target.value)}
            placeholder="/products"
          />
          <Button
            variant="primary"
            size="sm"
            loading={isUpdating}
            onClick={() => onUpdateEndpoint?.(intent, endpointUrl)}
          >
            Save URL
          </Button>
        </div>
      </div>

      <div className="response-box section-gap">
        <div className="intent-auth-row">
          <strong className="response-label">Auth Key</strong>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setShowAuthKey((prev) => !prev)}
          >
            {showAuthKey ? "Hide Key" : "Show Key"}
          </Button>
        </div>
        <div className="intent-auth-key-value">
          {showAuthKey ? intent.authKey : intent.authKeyMasked}
        </div>
      </div>

      <div className="info-list section-gap">
        <div className="info-item">
          <span className="info-label">Updated</span>
          <span className="info-value">{intent.updatedAt}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Created</span>
          <span className="info-value">{intent.createdAt}</span>
        </div>
      </div>
    </Card>
  );
}

export default IntentCard;
